// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.report-search-modal .ant-modal-content {
  border-radius: 10px;
  overflow: hidden;
  -webkit-box-shadow: 0 12px 32px rgba(0, 0, 0, 0.13);
          box-shadow: 0 12px 32px rgba(0, 0, 0, 0.13);
  padding: 0;
}

.report-search-modal .ant-modal-close {
  top: 10px;
  right: 14px;
}

.rs-modal-header {
  padding: 10px;
  border-bottom: 1px solid #ebebeb;
  background: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: baseline;
      -ms-flex-align: baseline;
          align-items: baseline;
  gap: 10px;
}

.rs-modal-title {
  font-size: 14px;
  font-weight: 700;
  color: #1a1a2e;
}

.rs-body {
  padding: 5px;
  background: #f5f6f8;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 8px;
}

.rs-form {
  background: #fff;
  padding: 10px 14px 8px;
  border-radius: 8px;
  border: 1px solid #ebebeb;
  -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
          box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.rs-form .ant-form-item {
  margin-bottom: 0;
}

.rs-form .ant-form-item-label {
  display: none;
}

.rs-filters-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 10px;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  margin-bottom: 6px;
}

.rs-filters-row .ant-form-item {
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  min-width: 0;
}

.rs-filters-row .rs-field-keyword {
  -webkit-box-flex: 2;
      -ms-flex: 2;
          flex: 2;
}

.rs-filters-row .rs-field-sex {
  -webkit-box-flex: 0.6;
      -ms-flex: 0.6;
          flex: 0.6;
}

.rs-filters-row .rs-btn-row {
  -webkit-box-flex: 0;
      -ms-flex: none;
          flex: none;
}

.rs-form .ant-input,
.rs-form input {
  font-size: 11.5px;
}

.rs-form .ant-select-selector {
  font-size: 11.5px !important;
}

.rs-form .ant-picker-input > input {
  font-size: 11.5px;
}

.rs-btn-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 8px;
}

.rs-btn-search {
  background: #7d48d0 !important;
  border: #7d48d0 !important;
  font-size: 12px;
  font-weight: 600;
  border-radius: 5px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

.rs-btn-search:hover {
  -webkit-transform: translateY(-1px);
          transform: translateY(-1px);
  -webkit-box-shadow: 0 5px 12px rgba(125, 72, 208, 0.38) !important;
          box-shadow: 0 5px 12px rgba(125, 72, 208, 0.38) !important;
}

.rs-btn-clear {
  font-size: 12px;
  border-radius: 5px;
  color: #595959;
  border-color: #d9d9d9;
}

.rs-btn-excel {
  font-size: 12px;
  border-radius: 5px;
  color: #389e0d;
  border-color: #b7eb8f;
  background: #f6ffed;
}

.rs-btn-excel:hover {
  background: #d9f7be !important;
  border-color: #73d13d !important;
  color: #237804 !important;
}

.rs-btn-excel:disabled {
  opacity: 0.5;
}

.rs-result-count {
  font-size: 11px;
  font-weight: 500;
}

.rs-table-wrapper {
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ebebeb;
  -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
          box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

.rs-table .ant-table {
  font-size: 10px;
}

.rs-table .ant-table-thead > tr > th {
  background: #fafafa;
  font-size: 11px;
  font-weight: 700;
  color: #303030;
  padding: 5px 8px;
  border-bottom: 1px solid #ebebeb;
}

.rs-table .ant-table-tbody > tr > td {
  border-bottom: 1px solid #f5f5f5;
}

.rs-table .ant-table-tbody > tr:hover > td {
  background: #f0f7ff;
}

.rs-table .ant-table-expanded-row > td {
  background: #fffdf5;
  padding: 0 !important;
}

.rs-table .ant-table-expanded-row-fixed {
  padding: 0 !important;
  margin: 0 !important;
  width: 100% !important;
}

.rs-cell {
  font-size: 11.5px;
  color: #2d2d2d;
}

.rs-expanded-row {
  background: #fffdf5;
  font-size: 11.5px;
  line-height: 1.5;
  color: #4a4a4a;
  padding: 4px 8px !important;
  border-left: 3px solid #faad14;
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
}

.rs-snippet-text {
  font-family: Georgia, serif;
  font-size: 11.5px;
  color: #333;
}

.rs-highlight {
  background: #ffe58f;
  color: #7c4a00;
  font-weight: 700;
  padding: 0 2px;
}

.rs-pagination-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
  padding: 8px 12px;
  border-top: 1px solid #f0f0f0;
}

.rs-pagination-row .ant-pagination {
  font-size: 11px;
}
`, "",{"version":3,"sources":["webpack://./pages/ReportSearch/ReportSearch.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mDAA2C;UAA3C,2CAA2C;EAC3C,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,gBAAgB;EAChB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,2BAAqB;MAArB,wBAAqB;UAArB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,iDAAyC;UAAzC,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,SAAS;EACT,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAO;MAAP,WAAO;UAAP,OAAO;EACP,YAAY;AACd;;AAEA;EACE,mBAAO;MAAP,WAAO;UAAP,OAAO;AACT;;AAEA;EACE,qBAAS;MAAT,aAAS;UAAT,SAAS;AACX;;AAEA;EACE,mBAAU;MAAV,cAAU;UAAV,UAAU;AACZ;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iCAAyB;EAAzB,yBAAyB;AAC3B;;AAEA;EACE,mCAA2B;UAA3B,2BAA2B;EAC3B,kEAA0D;UAA1D,0DAA0D;AAC5D;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,iDAAyC;UAAzC,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,2BAA2B;EAC3B,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;EACzB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".report-search-modal .ant-modal-content {\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.13);\r\n  padding: 0;\r\n}\r\n\r\n.report-search-modal .ant-modal-close {\r\n  top: 10px;\r\n  right: 14px;\r\n}\r\n\r\n.rs-modal-header {\r\n  padding: 10px;\r\n  border-bottom: 1px solid #ebebeb;\r\n  background: #fff;\r\n  display: flex;\r\n  align-items: baseline;\r\n  gap: 10px;\r\n}\r\n\r\n.rs-modal-title {\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  color: #1a1a2e;\r\n}\r\n\r\n.rs-body {\r\n  padding: 5px;\r\n  background: #f5f6f8;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.rs-form {\r\n  background: #fff;\r\n  padding: 10px 14px 8px;\r\n  border-radius: 8px;\r\n  border: 1px solid #ebebeb;\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.rs-form .ant-form-item {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.rs-form .ant-form-item-label {\r\n  display: none;\r\n}\r\n\r\n.rs-filters-row {\r\n  display: flex;\r\n  gap: 10px;\r\n  align-items: center;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.rs-filters-row .ant-form-item {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.rs-filters-row .rs-field-keyword {\r\n  flex: 2;\r\n}\r\n\r\n.rs-filters-row .rs-field-sex {\r\n  flex: 0.6;\r\n}\r\n\r\n.rs-filters-row .rs-btn-row {\r\n  flex: none;\r\n}\r\n\r\n.rs-form .ant-input,\r\n.rs-form input {\r\n  font-size: 11.5px;\r\n}\r\n\r\n.rs-form .ant-select-selector {\r\n  font-size: 11.5px !important;\r\n}\r\n\r\n.rs-form .ant-picker-input > input {\r\n  font-size: 11.5px;\r\n}\r\n\r\n.rs-btn-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.rs-btn-search {\r\n  background: #7d48d0 !important;\r\n  border: #7d48d0 !important;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  border-radius: 5px;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.rs-btn-search:hover {\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 5px 12px rgba(125, 72, 208, 0.38) !important;\r\n}\r\n\r\n.rs-btn-clear {\r\n  font-size: 12px;\r\n  border-radius: 5px;\r\n  color: #595959;\r\n  border-color: #d9d9d9;\r\n}\r\n\r\n.rs-btn-excel {\r\n  font-size: 12px;\r\n  border-radius: 5px;\r\n  color: #389e0d;\r\n  border-color: #b7eb8f;\r\n  background: #f6ffed;\r\n}\r\n\r\n.rs-btn-excel:hover {\r\n  background: #d9f7be !important;\r\n  border-color: #73d13d !important;\r\n  color: #237804 !important;\r\n}\r\n\r\n.rs-btn-excel:disabled {\r\n  opacity: 0.5;\r\n}\r\n\r\n.rs-result-count {\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n}\r\n\r\n.rs-table-wrapper {\r\n  background: #fff;\r\n  border-radius: 8px;\r\n  border: 1px solid #ebebeb;\r\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);\r\n  overflow: hidden;\r\n}\r\n\r\n.rs-table .ant-table {\r\n  font-size: 10px;\r\n}\r\n\r\n.rs-table .ant-table-thead > tr > th {\r\n  background: #fafafa;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  color: #303030;\r\n  padding: 5px 8px;\r\n  border-bottom: 1px solid #ebebeb;\r\n}\r\n\r\n.rs-table .ant-table-tbody > tr > td {\r\n  border-bottom: 1px solid #f5f5f5;\r\n}\r\n\r\n.rs-table .ant-table-tbody > tr:hover > td {\r\n  background: #f0f7ff;\r\n}\r\n\r\n.rs-table .ant-table-expanded-row > td {\r\n  background: #fffdf5;\r\n  padding: 0 !important;\r\n}\r\n\r\n.rs-table .ant-table-expanded-row-fixed {\r\n  padding: 0 !important;\r\n  margin: 0 !important;\r\n  width: 100% !important;\r\n}\r\n\r\n.rs-cell {\r\n  font-size: 11.5px;\r\n  color: #2d2d2d;\r\n}\r\n\r\n.rs-expanded-row {\r\n  background: #fffdf5;\r\n  font-size: 11.5px;\r\n  line-height: 1.5;\r\n  color: #4a4a4a;\r\n  padding: 4px 8px !important;\r\n  border-left: 3px solid #faad14;\r\n  white-space: nowrap;\r\n  overflow-x: auto;\r\n  overflow-y: hidden;\r\n}\r\n\r\n.rs-snippet-text {\r\n  font-family: Georgia, serif;\r\n  font-size: 11.5px;\r\n  color: #333;\r\n}\r\n\r\n.rs-highlight {\r\n  background: #ffe58f;\r\n  color: #7c4a00;\r\n  font-weight: 700;\r\n  padding: 0 2px;\r\n}\r\n\r\n.rs-pagination-row {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  padding: 8px 12px;\r\n  border-top: 1px solid #f0f0f0;\r\n}\r\n\r\n.rs-pagination-row .ant-pagination {\r\n  font-size: 11px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
